import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/primary-school/layoutProps';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="zh" pageKey="kis-approach-to-a-transdisciplinary-programme-of-inquiry">
    <h1>京斯敦的超學科探究課程</h1>
    <p>在京斯敦，我們着重以下學科的重要性：語言；數學；社會學；科學；藝術；個人教育、社交教育和體育。</p>
    <p>課程的《學習範圍與順序》中詳細記載構成每個學科領域的知識、概念和技能，並設定對每個學科的總體要求。</p>
    <p>
      然而，我們認為單獨的學科來教育學生雖是必要，卻是不夠的。同樣重要的是，學生需要在一定的情境中掌握技能，探索與他們相關的學習內容，並超越傳統學科之間的界限開展學習。「要真正受到教育，學生還必須能夠在各個學科之間建立聯繫，發現將各個學科整合起來的方法，最終做到學以致用、知行合一」。(Boyer
      1995: 82)
    </p>
    <p>
      課程的超學科主題，含括了人類都會體驗的領域，對文化和種族背景各異的個人都別具意義。這些主題為所有開設小學項目課程的國際文憑學校具一致性的學習，並奠定了部分共同的基礎。它們提供了對本地問題和全球性問題一體化的機會，而這些問題都屬於小學項目書面課程──「我們希望學生學習什麼」的知識範疇。課程共有六個超學科主題：{' '}
    </p>
    <ul className="list">
      <li>我們是誰</li>
      <li>我們身處什麼時空</li>
      <li>我們如何表達自己</li>
      <li>世界如何運作</li>
      <li>我們如何組織自己</li>
      <li>共享地球</li>
    </ul>
    <p>
      學生在探究單元提供的情境中探究和學習本地和全球性問題，每個探究單元都針對一個具體的超學科主題。學生通過個人的視角和文化經驗來建立連繫，做出貢獻，並加深他們對問題的理解。
    </p>
    <p>
      <em>節錄自國際文憑組織文件《小學項目：實踐之基礎》(2009)</em>
    </p>
  </ContentLayout>
);
